/* Personnalisation des bijoux gravés (voir snippets/lod-gravure.liquid).
   Un seul moteur pour tous les bijoux gravés, réglé par bijou dans le champ produit lod.gravure.
   Les choix partent en propriétés du bijou ; dessin, verso et options payantes ajoutent leur
   supplément (ou le produit choisi, comme une breloque) dans le même ajout au panier
   (voir product-form.js : window.lodExtraItems). */
if (!customElements.get('lod-gravure')) {
  customElements.define('lod-gravure', class LodGravure extends HTMLElement {
    connectedCallback() {
      if (this.pret) return;
      this.pret = true;
      this.cfg = JSON.parse(this.querySelector('.lod-gr__cfg').textContent);
      // Forme du bijou (champ lod.forme) : « rond », ou par gravure { "Lui": "plaque" }, ou par version { "variantes": { "Drop": "goutte" } }
      if (this.cfg.important) this.classList.add('lod-gr--important');
      if (this.cfg.compact) this.classList.add('lod-gr--compact');
      // Petites vignettes (colliers à charms : une planche par charm, à faire tenir sur l'écran)
      if (this.cfg.mini) this.classList.add('lod-gr--mini');
      try { this.forme = JSON.parse(this.dataset.forme || 'null') || this.cfg.forme || ''; } catch (e) { this.forme = this.cfg.forme || ''; }
      try { this.sup = JSON.parse(this.querySelector('.lod-gr__sup').textContent) || []; } catch (e) { this.sup = []; }
      this.en = this.dataset.lang === 'en';
      this.polices = this.cfg.polices || [];
      this.prixDessin = this.cfg.prix_dessin == null ? 3 : Number(this.cfg.prix_dessin);
      this.prixVerso = this.cfg.prix_verso == null ? 2.5 : Number(this.cfg.prix_verso);
      this.construit();
      this.addEventListener('input', () => this.maj());
      this.addEventListener('change', () => this.maj());
      // La couleur choisie sur la fiche devient la couleur par défaut des bracelets
      const vr = document.querySelector('#MainContent variant-radios, #MainContent variant-selects');
      if (vr) vr.addEventListener('change', () => { this.couleurFiche(true); setTimeout(() => this.maj(), 80); });
      // Choix à faire avant les options du produit (sens d'une pierre, avant l'attache et la pierre)
      if (vr && this.cfg.avant_options) vr.parentNode.insertBefore(this, vr);
      this.couleurFiche(false);
      window.lodExtraItems = window.lodExtraItems || {};
      window.lodExtraItems[this.dataset.form] = [].concat(window.lodExtraItems[this.dataset.form] || [], () => this.extraItems());
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.maj());
      this.maj();
    }

    t(fr, en) { return this.en ? en : fr; }
    money(n) { return n.toFixed(2).replace('.', ',').replace(',00', '') + ' €'; }
    esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
    cle(p) { return p.cle || p.titre || ''; }
    // Prix du verso et du dessin : réglage de la gravure, sinon celui du bijou
    pv(p) { return p && p.prix_verso != null ? Number(p.prix_verso) : this.prixVerso; }
    pd(p) { return p && p.prix_dessin != null ? Number(p.prix_dessin) : this.prixDessin; }
    // Gravure payante dès qu'un texte est saisi (bijou vendu vierge, gravure en option)
    pr(p) { return Number(p && p.prix_recto != null ? p.prix_recto : this.cfg.prix_recto || 0); }
    // Classe de police d'après son nom (Classique, Plume royale, Traditionnelle, Moderne)
    classePolice(nom) {
      const n = (nom || '').toLowerCase();
      if (/plume/.test(n)) return 'lod-gr-f2';
      if (/tradi/.test(n)) return 'lod-gr-f3';
      if (/modern/.test(n)) return 'lod-gr-f4';
      return 'lod-gr-f1';
    }
    // Nom d'une propriété de commande : « Elle : gravure recto » ou « Gravure recto » s'il n'y a qu'une gravure
    nom(p, champ) { const c = this.cle(p); return c ? `${c} : ${champ}` : champ.charAt(0).toUpperCase() + champ.slice(1); }

    // Variante du supplément à ce prix (« Dessin gravé (+3 €) », « Gravure au verso (+2,50 €) »…)
    // (recherche par nom : les prix affichés changent avec la devise du visiteur)
    supplement(type, prix) {
      const montant = `(+${this.money(prix)})`.replace(/\s/g, '');
      const titre = (x) => x.title.replace(/\s/g, '');
      const v = this.sup.find((x) => titre(x).indexOf(montant) > -1 && x.title.toLowerCase().indexOf(type) > -1)
        || this.sup.find((x) => titre(x).indexOf(montant) > -1);
      return v ? v.id : null;
    }

    construit() {
      const box = this.querySelector('.lod-gr__personnes');
      const ap = this.querySelector('.lod-gr__apercus');
      const n = this.cfg.dessins || 0;
      const img = this.cfg.dessins_image;
      (this.cfg.personnes || []).forEach((p, k) => {
        const id = `${this.dataset.form}-p${k}`;
        const max = p.max || 20;
        const maxV = p.max_verso || max;
        const avecCouleur = p.couleur !== false && (this.cfg.couleur || []).length;
        const avecVerso = p.verso !== false && this.cfg.verso;
        const avecDessin = p.dessin !== false && n && img;
        // Numéros des dessins (la grande planche saute le n° 47, retiré)
        const num = (i) => (this.cfg.dessins_numeros || [])[i] || i + 1;
        const dessins = avecDessin ? Array.from({ length: n }, (_, i) =>
          `<label class="lod-gr__dessin" title="${this.t('Dessin', 'Drawing')} ${num(i)}"><input type="radio" name="${id}-dessin" value="${num(i)}" data-pos="${i + 1}"><span style="background-image:url('${img}');background-position:${n > 1 ? (i * 100) / (n - 1) : 0}% 0;background-size:${n * 100}% 100%"></span></label>`).join('') : '';
        const couleurs = avecCouleur ? this.cfg.couleur.map((c, i) =>
          `<label class="lod-gr__puce"><input type="radio" name="${id}-couleur" value="${this.esc(c)}"${i === 0 ? ' checked' : ''}><span>${this.esc(c)}</span></label>`).join('') : '';
        const titre = p.titre ? `<legend>${this.esc(p.titre)}${p.plaque ? ` <span class="lod-gr__plaque">${this.t('plaque', 'plate')} ${this.esc(p.plaque)}</span>` : ''}</legend>` : '';
        box.insertAdjacentHTML('beforeend', `
          <fieldset class="lod-gr__bloc lod-gr__personne${p.titre ? '' : ' lod-gr__personne--seule'}" data-k="${k}">
            ${titre}
            ${couleurs ? `<div class="lod-gr__ligne"><span class="lod-gr__label">${this.esc(p.label_couleur || this.t('Couleur de la gourmette', 'Bracelet colour'))}</span><div class="lod-gr__puces">${couleurs}</div></div>` : ''}
            <div class="lod-gr__ligne">
              <label class="lod-gr__label" for="${id}-recto">${this.esc(p.label_recto || this.t('Texte gravé', 'Engraved text'))}${p.recto_requis ? ' *' : ''}${this.pr(p) ? ` <em>+ ${this.money(this.pr(p))}</em>` : ''}</label>
              <input class="lod-gr__texte" data-champ="recto" id="${id}-recto" type="text" maxlength="${max}" autocomplete="off" placeholder="${this.esc(p.exemple || this.t('Prénom, date, mot doux…', 'Name, date, sweet word…'))}">
              <span class="lod-gr__compte"><span>0</span>/${max}</span>
            </div>
            ${avecVerso ? `
            <label class="lod-gr__option"><input type="checkbox" data-champ="verso-on"> ${this.t('Graver aussi le verso', 'Also engrave the back')} <em>${this.pv(p) ? `+ ${this.money(this.pv(p))}` : this.t('offert', 'free')}</em></label>
            <div class="lod-gr__ligne lod-gr__verso" hidden>
              <label class="lod-gr__label" for="${id}-verso">${this.t('Texte au verso', 'Text on the back')}</label>
              <input class="lod-gr__texte" data-champ="verso" id="${id}-verso" type="text" maxlength="${maxV}" autocomplete="off">
              <span class="lod-gr__compte"><span>0</span>/${maxV}</span>
            </div>` : ''}
            ${dessins ? `
            <label class="lod-gr__option"><input type="checkbox" data-champ="dessin-on"> ${this.t('Ajouter un dessin au recto', 'Add a drawing on the front')} <em>${this.pd(p) ? `+ ${this.money(this.pd(p))}` : this.t('offert', 'free')}</em></label>
            <div class="lod-gr__dessins" hidden>
              <p class="lod-gr__aide">${this.t('Gravé au recto, à côté de votre texte. Avec un dessin, il reste un peu moins de place pour les lettres.', 'Engraved on the front, next to your text. With a drawing, there is a little less room for letters.')}</p>
              <div class="lod-gr__grille${n > 20 ? ' lod-gr__grille--grande' : ''}">${dessins}</div>
              <div class="lod-gr__ligne lod-gr__emplacement">
                <span class="lod-gr__label">${this.t('Emplacement du dessin', 'Drawing position')}</span>
                <div class="lod-gr__puces">
                  <label class="lod-gr__puce"><input type="radio" name="${id}-pos" value="debut"><span>${this.t('Avant le texte', 'Before the text')}</span></label>
                  <label class="lod-gr__puce"><input type="radio" name="${id}-pos" value="milieu"><span>${this.t('Au milieu', 'In the middle')}</span></label>
                  <label class="lod-gr__puce"><input type="radio" name="${id}-pos" value="fin" checked><span>${this.t('Après le texte', 'After the text')}</span></label>
                </div>
              </div>
            </div>` : ''}
          </fieldset>`);
        if (!this.cfg.rendu) ap.insertAdjacentHTML('beforeend', `
          <div class="lod-gr__apercu" data-k="${k}">
            ${p.titre ? `<span class="lod-gr__apercu-nom">${this.esc(p.titre)}</span>` : ''}
            <div class="lod-gr__plaq lod-gr__zone" data-cle="${this.esc(this.cle(p))}">
              <span class="lod-gr__grav-photo" data-part="a"></span><span class="lod-gr__dessin-photo" hidden></span><span class="lod-gr__grav-photo" data-part="b"></span>
            </div>
          </div>`);
      });
      this.querySelectorAll('.lod-gr__police-nom').forEach((el) => { el.className = `lod-gr__police-nom ${this.classePolice(el.textContent)}`; });
      // Plusieurs gravures simples (un texte chacune) : présentation compacte
      const pp = this.cfg.personnes || [];
      this.simples = pp.length > 1 && pp.every((p) => p.verso === false && p.dessin === false && p.couleur === false);
      if (this.simples) this.classList.add('lod-gr--medailles');
      this.construitMedailles();
      this.construitChoix();
      if (this.cfg.rendu) this.construitRendu(ap);
      else {
        this.zones = [...ap.querySelectorAll('.lod-gr__zone')];
        if (window.ResizeObserver) new ResizeObserver(() => this.maj()).observe(ap);
      }
    }

    // Nombre de médaillons (bracelets charms) : un texte par médaillon, supplément selon le nombre
    construitMedailles() {
      const m = this.cfg.medailles;
      if (!m) return;
      const box = this.querySelector('.lod-gr__choix[data-position="avant"]');
      const id = `${this.dataset.form}-nb`;
      const max = m.max || (this.cfg.personnes || []).length;
      const prix = m.prix || [];
      const opts = Array.from({ length: max }, (_, i) => {
        const p = Number(prix[i] || 0);
        return `<label class="lod-gr__puce lod-gr__puce--nb"><input type="radio" name="${id}" data-nb value="${i + 1}"${i === 0 ? ' checked' : ''}><span>${i + 1}${p ? `<em>+ ${this.money(p)}</em>` : `<em>${this.t('inclus', 'included')}</em>`}</span></label>`;
      }).join('');
      box.insertAdjacentHTML('beforeend', `
        <div class="lod-gr__bloc lod-gr__ligne">
          <span class="lod-gr__label">${this.esc(m.label || this.t('Nombre de médaillons', 'Number of charms'))}</span>
          <div class="lod-gr__puces lod-gr__puces--nb">${opts}</div>
        </div>`);
      this.classList.add('lod-gr--medailles');
    }

    nbMedailles() {
      if (!this.cfg.medailles) return Infinity;
      const el = this.querySelector('input[data-nb]:checked');
      return el ? Number(el.value) : 1;
    }

    // Options du bijou : longueur de chaîne, pierre de naissance… (avec supplément ou produit ajouté)
    construitChoix() {
      (this.cfg.choix || []).forEach((c, k) => {
        const box = this.querySelector(`.lod-gr__choix[data-position="${c.position === 'avant' ? 'avant' : 'apres'}"]`);
        const id = `${this.dataset.form}-c${k}`;
        const opts = c.options || [];
        const prix = (o) => (o.prix ? ` <em>+ ${this.money(Number(o.prix))}</em>` : '');
        const liste = c.style !== 'vignettes' && c.style !== 'pastilles' && (opts.length > 6 || c.style === 'liste');
        // Choix en photo (charms…) : vignettes d'une planche, côte à côte
        const nbV = Number(c.vignettes_n || opts.length);
        const vignette = (o) => `background-image:url('${c.vignettes}');background-size:${nbV * 100}% 100%;background-position:${nbV > 1 ? (Number(o.img) * 100) / (nbV - 1) : 0}% 0`;
        // Pastilles côte à côte (sens d'une pierre…), avec une mini-photo si une planche est donnée
        const pastilles = () => `<div class="lod-gr__seg" role="radiogroup">${opts.map((o, i) => `<label class="lod-gr__seg-opt"><input type="radio" name="${id}" data-choix="${k}" value="${i}"${o.defaut ? ' checked' : ''}><span>${c.vignettes ? `<i style="${vignette(o)}"></i>` : ''}<b>${this.esc(o.court || o.v)}</b>${o.aide ? `<small>${this.esc(o.aide)}</small>` : ''}</span></label>`).join('')}</div>`;
        const champ = c.style === 'pastilles' ? pastilles() : c.style === 'vignettes'
          ? `<div class="lod-gr__grille lod-gr__grille--photos">${opts.map((o, i) => `<label class="lod-gr__dessin lod-gr__vignette" title="${this.esc(o.v)}"><input type="radio" name="${id}" data-choix="${k}" value="${i}"${o.defaut ? ' checked' : ''}><span style="${vignette(o)}"></span><small>${this.esc(o.court || o.v)}</small></label>`).join('')}</div>`
          : liste
          ? `<select class="lod-gr__select" id="${id}" data-choix="${k}">${opts.map((o, i) => `<option value="${i}"${o.defaut || (i === 0 && !c.requis) ? ' selected' : ''}>${this.esc(o.v)}${o.prix ? ` (+ ${this.money(Number(o.prix))})` : ''}</option>`).join('')}</select>`
          : `<div class="lod-gr__puces">${opts.map((o, i) => `<label class="lod-gr__puce"><input type="radio" name="${id}" data-choix="${k}" value="${i}"${o.defaut || (i === 0 && !c.requis) ? ' checked' : ''}><span>${this.esc(o.v)}${prix(o)}</span></label>`).join('')}</div>`;
        box.insertAdjacentHTML('beforeend', `
          <div class="lod-gr__bloc lod-gr__ligne" data-choix-bloc="${k}">
            <label class="lod-gr__label"${liste ? ` for="${id}"` : ''}>${this.esc(c.label)}</label>
            ${c.aide ? `<span class="lod-gr__aide">${this.esc(c.aide)}</span>` : ''}
            ${champ}
          </div>`);
      });
    }

    // Rendu sur la photo du bijou : chaque texte est posé sur sa plaque, dans la police choisie
    construitRendu(ap) {
      const r = this.cfg.rendu;
      ap.classList.add('lod-gr__apercus--rendu');
      const plaques = (r.plaques || []).map((q) => `
        <div class="lod-gr__zone" data-cle="${this.esc(q.cle)}" style="left:${q.x}%;top:${q.y}%;width:${q.l}%;height:${q.h}%;transform:translate(-50%,-50%) rotate(${q.a}deg)">
          <span class="lod-gr__grav-photo" data-part="a"></span><span class="lod-gr__dessin-photo" hidden></span><span class="lod-gr__grav-photo" data-part="b"></span>
        </div>`).join('');
      ap.insertAdjacentHTML('beforeend', `
        <div class="lod-gr__rendu">
          <img class="lod-gr__photo lod-gr__photo--dore" src="${r.dore}" alt="" loading="lazy" width="1000" height="1000">
          ${r.argent ? `<img class="lod-gr__photo lod-gr__photo--argent" src="${r.argent}" alt="" loading="lazy" width="1000" height="1000">` : ''}
          ${plaques}
        </div>
        <p class="lod-gr__aide lod-gr__aide--rendu">${this.t('Touchez la photo pour l\'agrandir. Aperçu indicatif : le rendu gravé au laser peut varier légèrement.', 'Tap the photo to enlarge it. Indicative preview: the laser engraving may vary slightly.')}</p>`);
      const rendu = ap.querySelector('.lod-gr__rendu');
      this.renduEl = rendu;
      this.zones = [...rendu.querySelectorAll('.lod-gr__zone')];
      if (window.ResizeObserver) new ResizeObserver(() => this.maj()).observe(rendu);
      // Zoom : un clic affiche le rendu en grand, au-dessus de la page
      rendu.setAttribute('role', 'button');
      rendu.setAttribute('tabindex', '0');
      rendu.setAttribute('aria-label', this.t('Agrandir l\'aperçu de la gravure', 'Enlarge the engraving preview'));
      const place = document.createComment('rendu');
      const bascule = () => {
        const g = !rendu.classList.contains('is-grand');
        if (g) { rendu.parentNode.insertBefore(place, rendu); document.body.appendChild(rendu); }
        else if (place.parentNode) place.parentNode.replaceChild(rendu, place);
        rendu.classList.toggle('is-grand', g);
        document.body.classList.toggle('lod-gr-zoom', g);
        setTimeout(() => this.maj(), 30);
      };
      rendu.addEventListener('click', (e) => { e.stopPropagation(); bascule(); });
      rendu.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); bascule(); } });
      document.addEventListener('click', () => { if (rendu.classList.contains('is-grand')) bascule(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && rendu.classList.contains('is-grand')) bascule(); });
    }

    couleurFiche(force) {
      const cs = this.cfg.couleur || [];
      if (!cs.length) return;
      const val = this.couleurVariante();
      const cible = cs.find((c) => val && val.indexOf(c.toLowerCase().slice(0, 4)) > -1);
      if (!cible) return;
      this.querySelectorAll('.lod-gr__personne').forEach((fs) => {
        const r = [...fs.querySelectorAll('input[type=radio][name$="-couleur"]')];
        if (force || !fs.dataset.touche) r.forEach((i) => { i.checked = i.value === cible; });
      });
      if (!force) this.querySelectorAll('.lod-gr__personne .lod-gr__puces').forEach((p) => p.addEventListener('change', () => { p.closest('.lod-gr__personne').dataset.touche = '1'; }, { once: true }));
    }

    // Valeur (en minuscules) de l'option couleur de la variante choisie sur la fiche
    couleurVariante() {
      const v = this.variante();
      if (!v) return '';
      return [v.option1, v.option2, v.option3].map((o) => String(o || '').split(' · ')[0]).join(' ').toLowerCase();
    }

    variante() {
      try {
        const id = (document.querySelector(`#${this.dataset.form} [name="id"]`) || {}).value;
        const vr = document.querySelector('#MainContent variant-radios script[type="application/json"], #MainContent variant-selects script[type="application/json"]');
        return JSON.parse(vr.textContent).find((x) => String(x.id) === String(id));
      } catch (e) { return null; }
    }

    lecture() {
      const police = (this.querySelector('input[name^="lod-gr-police"]:checked') || {}).value || '';
      const pIndex = Math.max(0, this.polices.indexOf(police));
      const nb = this.nbMedailles();
      // Gravure liée à une version (porte-clés « Pour Elle », « Pour Lui »…) : visible seulement avec cette version
      const v = this.variante();
      const titreV = v ? (v.title || [v.option1, v.option2, v.option3].join(' ')).toLowerCase() : '';
      const visible = (k) => {
        const p = this.cfg.personnes[k] || {};
        if (k >= nb) return false;
        return !p.si_variante || !titreV || titreV.indexOf(String(p.si_variante).toLowerCase()) > -1;
      };
      this.querySelectorAll('.lod-gr__personne').forEach((fs) => { fs.hidden = !visible(Number(fs.dataset.k)); });
      this.querySelectorAll('.lod-gr__apercu').forEach((a) => { a.hidden = !visible(Number(a.dataset.k)); });
      const pers = [...this.querySelectorAll('.lod-gr__personne')].filter((fs) => !fs.hidden).map((fs) => {
        const k = Number(fs.dataset.k);
        const p = this.cfg.personnes[k];
        const q = (s) => fs.querySelector(s);
        const versoOn = !!(q('[data-champ="verso-on"]') && q('[data-champ="verso-on"]').checked);
        const dessinOn = !!(q('[data-champ="dessin-on"]') && q('[data-champ="dessin-on"]').checked);
        const choixD = dessinOn ? fs.querySelector('input[name$="-dessin"]:checked') : null;
        const dessin = choixD ? choixD.value : '';
        const dessinPos = choixD ? Number(choixD.dataset.pos) : 0;
        const couleurPerso = (fs.querySelector('input[name$="-couleur"]:checked') || {}).value;
        return {
          fs, k, p,
          couleur: couleurPerso || this.couleurVariante(),
          couleurPerso: !!couleurPerso,
          recto: (q('[data-champ="recto"]').value || '').trim(),
          versoOn, verso: versoOn ? (q('[data-champ="verso"]').value || '').trim() : '',
          dessinOn, dessin, dessinPos,
          pos: (fs.querySelector('input[name$="-pos"]:checked') || {}).value || 'fin',
        };
      });
      const choix = (this.cfg.choix || []).map((c, k) => {
        const el = this.querySelector(`select[data-choix="${k}"]`) || this.querySelector(`input[data-choix="${k}"]:checked`);
        const o = el ? c.options[Number(el.value)] : null;
        return { c, o, k, idx: el ? Number(el.value) : -1 };
      });
      // Choix affiché seulement selon un autre choix (« Je mixe les tailles » → une taille par bague)
      choix.forEach((x) => {
        if (!x.c.si) return;
        const ref = choix.find((y) => y.c.cle === x.c.si.cle);
        const vis = !!ref && ref.idx === Number(x.c.si.index);
        const bloc = this.querySelector(`[data-choix-bloc="${x.k}"]`);
        if (bloc) bloc.hidden = !vis;
        if (!vis) { x.o = null; x.cache = true; }
      });
      return { police, pIndex, pers, choix, nb };
    }

    // Forme de chaque plaque d'aperçu, d'après le bijou, la gravure ou la version choisie
    majFormes() {
      const f = this.forme;
      if (!f) return;
      const v = this.variante();
      const titreV = v ? String(v.title || '').toLowerCase() : '';
      const parVersion = f.variantes ? Object.keys(f.variantes).find((k) => titreV.indexOf(k.toLowerCase()) > -1) : null;
      this.querySelectorAll('.lod-gr__apercu .lod-gr__plaq').forEach((z) => {
        const forme = typeof f === 'string' ? f : (f[z.dataset.cle] || (parVersion && f.variantes[parVersion]) || f.defaut || '');
        if (forme) z.dataset.forme = forme; else delete z.dataset.forme;
      });
    }

    maj() {
      this.majFormes();
      const { pIndex, pers, choix, nb } = this.lecture();
      let total = 0;
      const lignes = [];
      const prixNb = this.cfg.medailles ? Number((this.cfg.medailles.prix || [])[nb - 1] || 0) : 0;
      if (prixNb) { total += prixNb; lignes.push(this.t(`${nb} médaillons + ${this.money(prixNb)}`, `${nb} charms + ${this.money(prixNb)}`)); }
      const multi = pers.length > 1;
      pers.forEach((x) => {
        x.fs.querySelectorAll('.lod-gr__texte').forEach((i) => { i.nextElementSibling.querySelector('span').textContent = i.value.length; });
        const v = x.fs.querySelector('.lod-gr__verso'); if (v) v.hidden = !x.versoOn;
        const d = x.fs.querySelector('.lod-gr__dessins'); if (d) d.hidden = !x.dessinOn;
        const qui = multi ? ` ${x.p.titre.toLowerCase()}` : '';
        if (x.recto && this.pr(x.p)) { total += this.pr(x.p); lignes.push(this.t(`gravure${qui} + ${this.money(this.pr(x.p))}`, `engraving${qui} + ${this.money(this.pr(x.p))}`)); }
        if (x.verso && this.pv(x.p)) { total += this.pv(x.p); lignes.push(this.t(`verso gravé${qui} + ${this.money(this.pv(x.p))}`, `back engraving${qui} + ${this.money(this.pv(x.p))}`)); }
        if (x.dessin && this.pd(x.p)) { total += this.pd(x.p); lignes.push(this.t(`dessin n° ${x.dessin}${qui} + ${this.money(this.pd(x.p))}`, `drawing no. ${x.dessin}${qui} + ${this.money(this.pd(x.p))}`)); }
      });
      choix.forEach(({ c, o }) => {
        if (o && o.prix) { total += Number(o.prix); lignes.push(`${(c.court || c.label).replace(/\s*:\s*$/, '').toLowerCase()} ${o.v} + ${this.money(Number(o.prix))}`); }
      });
      this.majRendu(pers);
      this.poseTextes(pIndex, pers);
      const tot = this.querySelector('.lod-gr__total');
      tot.hidden = !total;
      const v = this.variante();
      const base = v ? v.price / 100 : Number(this.dataset.prix || 0) / 100;
      tot.innerHTML = total ? `<span>${this.t('Options choisies', 'Selected options')} : ${lignes.map((l) => this.esc(l)).join(', ')}.</span>${base ? `<strong>${this.t('Total', 'Total')} : ${this.money(base + total)}</strong>` : ''}` : '';
      const err = this.querySelector('.lod-gr__erreur');
      if (!err.hidden) err.hidden = true;
    }

    // Photo dorée ou argentée ; avec un masque, chaque gourmette peut prendre sa propre couleur
    majRendu(pers) {
      const ap = this.renduEl;
      if (!ap) return;
      const r = this.cfg.rendu;
      const dore = ap.querySelector('.lod-gr__photo--dore');
      const arg = ap.querySelector('.lod-gr__photo--argent');
      if (!arg) return;
      const qD = (r.plaques || []).find((q) => q.masque);
      const xD = qD && pers.find((x) => this.cle(x.p) === qD.cle);
      const xG = pers.find((x) => !qD || this.cle(x.p) !== qD.cle);
      const gA = !!(xG && /argent/i.test(xG.couleur));
      const dA = xD ? /argent/i.test(xD.couleur) : gA;
      const fond = gA ? arg : dore;
      const dessus = gA ? dore : arg;
      fond.style.cssText = 'z-index:0;clip-path:none;opacity:1';
      if (gA === dA) dessus.style.cssText = 'z-index:1;opacity:0';
      else dessus.style.cssText = `z-index:1;opacity:1;clip-path:polygon(${qD.masque})`;
    }

    // Texte et dessin sur chaque plaque (photo du bijou ou plaque dessinée)
    poseTextes(pIndex, pers) {
      const n = this.cfg.dessins || 0;
      const img = this.cfg.dessins_masque;
      const plaquesCfg = (this.cfg.rendu && this.cfg.rendu.plaques) || [];
      (this.zones || []).forEach((z) => {
        const x = pers.find((y) => this.cle(y.p) === z.dataset.cle);
        const q = plaquesCfg.find((p) => p.cle === z.dataset.cle) || {};
        const ga = z.querySelector('[data-part="a"]');
        const gb = z.querySelector('[data-part="b"]');
        const d = z.querySelector('.lod-gr__dessin-photo');
        const h = z.clientHeight;
        const photo = !!this.cfg.rendu;
        z.style.setProperty('--dy', `${((q.dy || 0) * h) / 100}px`);
        const argent = !!(x && /argent/i.test(x.couleur));
        z.classList.toggle('is-argent', argent);
        const ap = z.closest('.lod-gr__apercu');
        if (ap) ap.classList.toggle('is-argent', argent);
        const texte = x ? (x.recto || (x.dessin ? '' : this.t('Votre texte', 'Your text'))) : '';
        // Le dessin se place avant, au milieu ou après le texte, comme choisi
        let a1 = texte, b1 = '';
        const avecDessin = !!(x && x.dessin && img && n);
        if (avecDessin) {
          if (x.pos === 'debut') { a1 = ''; b1 = texte; }
          else if (x.pos === 'milieu' && texte) {
            const mil = texte.length / 2;
            const esp = [...texte].map((c, i) => (c === ' ' ? i : -1)).filter((i) => i > -1).sort((u, v) => Math.abs(u - mil) - Math.abs(v - mil))[0];
            const cut = esp != null ? esp : Math.round(mil);
            a1 = texte.slice(0, cut).trim(); b1 = texte.slice(cut).trim();
          }
        }
        [ga, gb].forEach((g, i) => {
          g.className = `lod-gr__grav-photo ${this.classePolice(this.polices[pIndex])}${x && !x.recto ? ' is-vide' : ''}`;
          g.textContent = i ? b1 : a1;
          g.hidden = !(i ? b1 : a1);
        });
        if (avecDessin) {
          d.hidden = false;
          const url = `url('${img}')`;
          const pos = `${n > 1 ? ((x.dessinPos - 1) * 100) / (n - 1) : 0}% 0`;
          d.style.cssText = `-webkit-mask-image:${url};mask-image:${url};-webkit-mask-size:${n * 100}% 100%;mask-size:${n * 100}% 100%;-webkit-mask-position:${pos};mask-position:${pos}`;
        } else d.hidden = true;
        // Taille de départ selon la hauteur de la plaque, puis le texte rétrécit pour tenir
        const script = this.classePolice(this.polices[pIndex]) === 'lod-gr-f2';
        let fs = photo ? Math.max(8, h * (script ? 1.12 : 0.95)) : Math.min(h * (script ? 0.62 : 0.48), 26);
        const tailles = () => { [ga, gb].forEach((g) => { g.style.fontSize = fs + 'px'; }); if (!d.hidden) { d.style.width = d.style.height = fs * 1.2 + 'px'; } };
        const vis = () => [ga, d, gb].filter((e) => !e.hidden);
        const largeur = () => vis().reduce((t, e) => t + e.offsetWidth, 0) + fs * 0.25 * (vis().length - 1);
        tailles();
        while (largeur() > z.clientWidth * (q.remplissage || (photo ? 0.9 : 0.84)) && fs > 6) { fs -= 0.5; tailles(); }
      });
    }

    erreur(msg, el) {
      const e = this.querySelector('.lod-gr__erreur');
      e.textContent = msg; e.hidden = false;
      (el || e).scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (el && el.focus) el.focus({ preventScroll: true });
      return { error: msg, items: [], mainProperties: {} };
    }

    extraItems() {
      const { police, pers, choix, nb } = this.lecture();
      const requis = pers.find((x) => (x.p.recto_requis || this.cfg.medailles) && !x.recto);
      if (requis) return this.erreur(this.t('Indiquez le texte à graver.', 'Enter the text to engrave.'), requis.fs.querySelector('[data-champ="recto"]'));
      if (!this.cfg.gravure_facultative && !pers.some((x) => x.recto || x.dessin)) {
        return this.erreur(this.t(pers.length > 1 ? 'Indiquez le texte à graver sur au moins une gourmette.' : 'Indiquez le texte à graver.', 'Enter the text to engrave.'), pers[0] && pers[0].fs.querySelector('[data-champ="recto"]'));
      }
      for (const x of pers) {
        const qui = pers.length > 1 ? ` ${x.p.titre.toLowerCase()}` : '';
        if (x.dessinOn && !x.dessin) return this.erreur(this.t(`Choisissez le dessin${qui}, ou décochez « Ajouter un dessin au recto ».`, `Choose the drawing${qui}, or untick "Add a drawing".`), x.fs.querySelector('.lod-gr__grille'));
        if (x.versoOn && !x.verso) return this.erreur(this.t(`Indiquez le texte du verso${qui}, ou décochez « Graver aussi le verso ».`, `Enter the back text${qui}, or untick "Also engrave the back".`), x.fs.querySelector('[data-champ="verso"]'));
      }
      for (const { c, o, cache } of choix) {
        if (c.requis && !o && !cache) return this.erreur(this.t(`Choisissez : ${c.label.replace(/\s*:\s*$/, '')}.`, `Choose: ${c.label}.`), this.querySelector(`[data-choix-bloc="${choix.findIndex((y) => y.c === c)}"]`));
      }
      const mp = {};
      const items = [];
      const pour = this.dataset.produit;
      const ajoute = (type, prix, props) => {
        const id = this.supplement(type, prix);
        if (id) items.push({ id: Number(id), quantity: 1, properties: props });
        return !!id;
      };
      if (police) mp[this.t('Police', 'Font')] = police;
      if (this.cfg.medailles) {
        mp[this.cfg.medailles.court || this.t('Nombre de médaillons', 'Number of charms')] = String(nb);
        const prixNb = Number((this.cfg.medailles.prix || [])[nb - 1] || 0);
        if (prixNb && !ajoute('médaillon', prixNb, { [this.t('Pour', 'For')]: pour, [this.t('Option', 'Option')]: this.t(`${nb} médaillons`, `${nb} charms`) })) return this.erreur(this.t('Option indisponible pour le moment, écrivez-nous sur WhatsApp.', 'Option unavailable, please contact us.'));
      }
      for (const x of pers) {
        const n = this.cle(x.p);
        const pourQui = n ? `${pour}, ${n}` : pour;
        if (x.couleurPerso) mp[this.nom(x.p, this.t('couleur', 'colour'))] = x.couleur;
        if (x.recto) mp[this.cfg.medailles || this.simples ? n : this.nom(x.p, x.p.nom_recto || this.t('gravure recto', 'front engraving'))] = x.recto;
        if (x.recto && this.pr(x.p) && !ajoute('gravure (', this.pr(x.p), { [this.t('Pour', 'For')]: pourQui })) return this.erreur(this.t('Option indisponible pour le moment, écrivez-nous sur WhatsApp.', 'Option unavailable, please contact us.'));
        if (x.verso) {
          mp[this.nom(x.p, this.t('gravure verso', 'back engraving'))] = x.verso;
          if (this.pv(x.p) && !ajoute('verso', this.pv(x.p), { [this.t('Pour', 'For')]: pourQui })) return this.erreur(this.t('Option indisponible pour le moment, écrivez-nous sur WhatsApp.', 'Option unavailable, please contact us.'));
        }
        if (x.dessin) {
          mp[this.nom(x.p, this.t('dessin', 'drawing'))] = `n° ${x.dessin}`;
          mp[this.nom(x.p, this.t('emplacement du dessin', 'drawing position'))] = { debut: this.t('avant le texte', 'before the text'), milieu: this.t('au milieu du texte', 'in the middle of the text'), fin: this.t('après le texte', 'after the text') }[x.pos];
          if (this.pd(x.p) && !ajoute('dessin', this.pd(x.p), { [this.t('Pour', 'For')]: pourQui, [this.t('Dessin', 'Drawing')]: `n° ${x.dessin}` })) return this.erreur(this.t('Option indisponible pour le moment, écrivez-nous sur WhatsApp.', 'Option unavailable, please contact us.'));
        }
      }
      // Options : on note le choix ; un produit associé (breloque…) part dans le panier, dans la couleur du bijou
      for (const { c, o } of choix) {
        if (!o) continue;
        // « Aucune », « Sans pierre… » : rien à noter sur la commande
        if (!o.prix && !o.ajout && /^(aucune?|sans)\b/i.test(o.v)) continue;
        mp[(c.court || c.label).replace(/\s*:\s*$/, '')] = o.v;
        if (o.ajout) {
          const arg = /argent/i.test(this.couleurVariante() || (pers[0] && pers[0].couleur) || '');
          const id = (arg && o.ajout.argent) || o.ajout.dore || o.ajout.id;
          if (id) items.push({ id: Number(id), quantity: 1, properties: { [this.t('Pour', 'For')]: pour } });
        } else if (o.prix) {
          if (!ajoute('option', Number(o.prix), { [this.t('Pour', 'For')]: pour, [this.t('Option', 'Option')]: `${(c.court || c.label).replace(/\s*:\s*$/, '')} : ${o.v}` })) return this.erreur(this.t('Option indisponible pour le moment, écrivez-nous sur WhatsApp.', 'Option unavailable, please contact us.'));
        }
      }
      const com = this.querySelector('.lod-gr__com');
      if (com && com.value.trim()) mp[this.t('Précisions', 'Details')] = com.value.trim();
      return { mainProperties: mp, items };
    }
  });
}
